import { createFileRoute } from '@tanstack/react-router';

import { loadClientName } from '../clientTitle';
import { getLocalizedDynamicTitle } from '../title';

export const Route = createFileRoute('/_app/clients/$clientId/history')({
  loader: async ({ context, params }) => ({
    clientName: await loadClientName(context.apiClient, params.clientId),
  }),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: getLocalizedDynamicTitle(
          'clients.client_history.page_title',
          'Client History',
          loaderData?.clientName ?? '',
        ),
      },
    ],
  }),
});
